import { createSelector } from 'reselect';

import type { State } from '../store';
import { ClientName } from '~/constants';

export const selectEmbedParams = (state: State) => state.embed;

export const selectIsInAppMode = createSelector([selectEmbedParams], embedParams => {
  return Boolean(embedParams.appVersion);
});

export const selectClientName = createSelector([selectEmbedParams, selectIsInAppMode], (embedParams, isInAppMode) => {
  if (!isInAppMode) {
    const N12_MAIN_CHANNEL_ID = '31750a2610f26110VgnVCM1000005201000aRCRD';
    return embedParams.mainChannelId === N12_MAIN_CHANNEL_ID ? ClientName.N12 : ClientName.MAKO;
  }

  return embedParams.appName.toLowerCase() === 'news' ? ClientName.N12 : ClientName.MAKO;
});

export const selectVcmId = createSelector([selectEmbedParams], embedParams => {
  return embedParams.vcmId;
});

export const selectUserId = createSelector([selectEmbedParams], embedParams => {
  return embedParams.userId;
});

export const selectIsFullWidthMode = createSelector([selectEmbedParams], embedParams => {
  return embedParams.isFullWidth;
});

export const selectIsOpen = createSelector([selectEmbedParams], embedParams => {
  return embedParams.isOpen;
});

export const selectContentWidth = createSelector([selectEmbedParams], embedParams => {
  return embedParams.contentWidth;
});
